
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.727 24.6H4.191a3.697 3.697 0 01-3.625-2.995.738.738 0 01-.066-.306v-.071c0-.053.001-.106.004-.16A3.788 3.788 0 01.5 20.91V4.291A3.695 3.695 0 014.19.6h17.537c.41 0 .741.332.741.741V18.28c0 .409-.332.741-.74.741H4.19a2.21 2.21 0 00-2.202 2.049 2.21 2.21 0 002.202 2.048h17.536a.742.742 0 010 1.483zM4.191 2.083A2.21 2.21 0 001.983 4.29v13.982a3.673 3.673 0 012.208-.735h16.795V2.083H4.19z"}}),_c('path',{attrs:{"d":"M11.422 15.359a.829.829 0 11.002-1.658.829.829 0 01-.002 1.658zm0-1.483a.655.655 0 10.001 1.31.655.655 0 00-.001-1.31zM11.422 12.894a.742.742 0 01-.742-.741c0-2.264.806-2.91 1.704-3.421.496-.283.723-.412.723-1.357 0-.675-.242-1.114-.76-1.379a2.365 2.365 0 00-.923-.236 1.898 1.898 0 00-.83.248c-.493.293-.732.81-.732 1.58a.742.742 0 01-1.483 0c0-1.014.3-1.827.893-2.419.868-.865 2.012-.892 2.15-.892h.005c.152 0 1.43.028 2.336.932.549.548.828 1.276.828 2.165 0 1.808-.85 2.292-1.472 2.646-.554.316-.954.543-.954 2.132 0 .41-.332.742-.742.742h-.001z"}}),_c('path',{attrs:{"d":"M11.422 15.354a.823.823 0 100-1.646.823.823 0 000 1.646z"}})])
          )
        }
      }
    